<div class="modal__content">
  <div class="warning-header">
    <i class="fas fa-triangle-exclamation warning-icon"></i>
    <span class="warning-title">WARNING</span>
  </div>

  <div class="progress-warning">
    <strong>Progress may be lost.</strong> Clicking the step links below will not affect your saved data.
  </div>

  <div class="step-progress-wrapper">
    @for (step of steps; track step; let i = $index; let isLast = $last) {
      <div class="step-item" [ngClass]="getStepStatus(i)">
        <div class="step-circle">
          @if (getStepStatus(i) === 'completed') {
            <i class="fas fa-check"></i>
          }
          @if (getStepStatus(i) !== 'completed') {
            <span>{{i + 1}}</span>
          }
        </div>
        <div class="step-label">{{step.displayText}}</div>
      </div>
      @if (!isLast) {
        <div class="step-connector"></div>
      }
    }
  </div>

  <div class="detail-section">
    <div class="detail-header">However:</div>
    <div class="warning-box">
      If you go back to an earlier step and then click <strong>Next</strong>, any progress made in later steps will be <strong>discarded</strong>.
    </div>
    <div class="example-text">
      <em>Example: Manual data entered in the '{{steps[currentStepIndex]?.displayText}}' step will be lost if you return to the '{{steps[targetStepIndex]?.displayText}}' step and click Next.</em>
    </div>
  </div>
</div>

<div class="modal__footer">
  <button type="button" class="btn btn-link" (click)="answer(false);">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="answer(true)">Continue</button>
</div>

